import React from 'react';
import styled from 'styled-components';
import { StyledIcon, StyledLink } from '../../../components/buttons/shared.js';
import { HelpCircleIcon, MessageSquareIcon, } from '../../../components/icons/index.js';
import { grey128, grey24, grey32, grey8 } from '../../../style/colors.js';
export function HomeOverlay() {
    return (React.createElement(Container, null,
        React.createElement(Footer, null,
            React.createElement(FooterLink, { href: "https://github.com/react-cosmos/react-cosmos/releases", label: `v${VERSION}`, title: "Releases" }),
            React.createElement(FooterLink, { icon: React.createElement(HelpCircleIcon, null), href: "https://reactcosmos.org/docs/user-interface", title: "Documentation" }),
            React.createElement(FooterLink, { icon: React.createElement(MessageSquareIcon, null), href: "https://discord.gg/3X95VgfnW5", title: "Discord" }))));
}
const Container = styled.div `
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: ${grey8};
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
`;
const Footer = styled.div `
  height: 40px;
  padding: 0 4px;
  display: flex;
  align-items: center;
  gap: 4px;
  overflow-x: auto;
`;
function FooterLink(props) {
    const { href, icon, label, title } = props;
    return (React.createElement(StyledLink, { href: href, rel: "noopener noreferrer", target: "_blank", bg: grey8, bgSelect: grey32, bgHover: grey24, color: grey128, colorSelect: grey128, title: title, selected: false, disabled: false }, icon ? React.createElement(StyledIcon, { color: grey128 }, icon) : label));
}
